import { z } from "@/zod";
import { ulid } from "@/schemas/commonFields";
import {
  createNonNegativeDecimalStringSchema,
  nonNegativeDecimalStringSchema,
} from "@/schemas/commonFields/numberSchema";

const laborCostStoreNumericSchema = createNonNegativeDecimalStringSchema(3);

const optionalLaborCostDecimal = z.optional(
  z.coerce.string().pipe(laborCostStoreNumericSchema),
);

// technical schema to manage Labor Costs in Stores form state
export const invoiceSpecificationStoresFormSchema = z.object({
  stores: z.record(
    z.coerce.string(),
    z.object({
      id: ulid,
      store_id: ulid,
      hours: laborCostStoreNumericSchema,
      deduction: nonNegativeDecimalStringSchema,
      rate: laborCostStoreNumericSchema,
      planned_hours: nonNegativeDecimalStringSchema,
      include_on_invoice: z.boolean(),
      addition: laborCostStoreNumericSchema,

      roles: z.string().max(100).optional(),
      comment: z.string().optional(),
      departments: z.string().optional(),
      role_ids: z.string().optional(),
      department_ids: z.string().optional(),
      base_amount: optionalLaborCostDecimal,
      invoiced_amount: optionalLaborCostDecimal,
    }),
  ),
});

export type InvoiceSpecificationStoresForm = z.infer<
  typeof invoiceSpecificationStoresFormSchema
>;
